<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                 style="min-height: 500px; background-image: url(img/theme/nextlevel.jpg); background-size: cover; background-position: center top;">
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col">
            <h1 class="display-2 text-white">Hallo, {{ this.user.firstname && this.user.lastname ? this.user.firstname +
              ' ' + this.user.lastname : this.user.email }}</h1>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">

          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img :src="this.user.image" class="rounded-circle">
                </div>
              </div>
            </div>
            <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
              <div class="d-flex justify-content-between">
                <!--                <base-button class="mr-4" size="sm" type="info">Connect</base-button>-->
                <!--                <base-button class="float-right" size="sm" type="default">Message</base-button>-->
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                    <div>
                      <span class="heading">{{ this.customers.length }}</span>
                      <span class="description">Kunden</span>
                    </div>
                    <div>
                      <span class="heading">{{ this.projects.length }}</span>
                      <span class="description">Projekte</span>
                    </div>
                    <div>
                      <span class="heading">{{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.sales) }}</span>
                      <span class="description">Gewinn</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <h3>
                  {{ this.user.firstname && this.user.lastname ? this.user.firstname + ' ' + this.user.lastname :
                  'BENUTZER' }}<span class="font-weight-light"></span>
                </h3>
                <div class="h5 font-weight-300">
                  {{ this.user.email }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-8 order-xl-1 mb-5">
          <card shadow type="secondary">
            <div class="bg-white border-0" slot="header">
              <h3 class="mb-0">Mein Account</h3>
            </div>
            <template>
              <form @submit.prevent>
                <label for="exampleFormControlFile1">Profilbild auswählen</label>
                <input @change="previewImage" accept="image/*" class="form-control-file" id="exampleFormControlFile1"
                       type="file">

                <base-progress :height="8" :value="uploadValue" label="Hochladen..." type="default"
                               v-if="this.upload"></base-progress>

                <div class="text-right">
                  <base-button @click="onUpload" class="mt-4" type="default" v-if="this.imageData!=null">Hochladen
                  </base-button>
                </div>
              </form>

              <hr/>

              <form @submit.prevent>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group" data-v-e928b7d8="">
                      <input :value="this.firstname" @input="updateFirstname" class="form-control"
                             placeholder="Nachname" type="text">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group" data-v-e928b7d8="">
                      <input :value="this.lastname" @input="updateLastname" class="form-control" placeholder="Nachname"
                             type="text">
                    </div>
                  </div>
                  <div class="col">
                    <input :value="this.email" class="form-control" disabled placeholder="Nachname" type="text">
                  </div>
                </div>

                <div class="text-right">
                  <base-button @click="userInformation" class="mt-4" type="default">Speichern</base-button>
                </div>

              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import store from '../store'
  import firebase from 'firebase/app';
  import { mapState } from "vuex";

  require('firebase/firestore');
  require('firebase/storage');

  export default {
    name: 'user-profile',
    computed: {
      ...mapState({
        user: state => state.user,
        lastname: state => state.user.lastname,
        firstname: state => state.user.firstname,
        email: state => state.user.email,
      })
    },
    created() {
      this.getUserInformations()
    },
    data() {
      return {
        imageData: null,
        upload: false,
        uploadValue: 0,
        isAdmin: Boolean,
        customers: [],
        projects: [],
        sales: 0,
      }
    },
    methods: {
      updateFirstname(e) {
        this.$store.commit('updateFirstname', e.target.value)
      },
      updateLastname(e) {
        this.$store.commit('updateLastname', e.target.value)
      },
      userInformation() {
        var userRef = firebase.firestore().collection("users").doc(this.user.uid);

        return userRef.update({
          firstname: this.firstname,
          lastname: this.lastname
        })
          .then(() => {
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            // eslint-disable-next-line no-console
            console.error("Error updating document: ", error);
          });
      },
      previewImage(event) {
        this.uploadValue = 0;
        this.imageData = event.target.files[0];
      },
      onUpload() {
        this.upload = true;
        const storageRef = firebase.storage().ref(`users/${ this.user.uid }/${ this.imageData.name }`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          }, error => {
            // eslint-disable-next-line no-console
            console.log(error.message)
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.upload = false;

              var userRef = firebase.firestore().collection("users").doc(store.state.user.uid);

              return userRef.update({
                image: String(url)
              })
                .then(() => {
                  store.commit('updatePicture', url);
                  // eslint-disable-next-line no-console
                  console.log("Document successfully updated!");
                })
                .catch(function (error) {
                  // The document probably doesn't exist.
                  // eslint-disable-next-line no-console
                  console.error("Error updating document: ", error);
                });
            });
          }
        );
      },
      getUserInformations() {
        firebase.firestore().collection("customers").where("user_id", "==", this.user.uid).onSnapshot((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.customers.push(doc.data())

            firebase.firestore().collection("projects").where("customer", "==", doc.id).onSnapshot((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                this.projects.push(doc.data())
                let sales = +doc.data().hours * +doc.data().hourly_rate

                this.sales = +this.sales + +sales
              });
            });
          });
        });
      }
    }
  };
</script>